export default function Tos() {
  return (
    <div className="bg-white min-h-screen py-16 px-6 sm:px-12 lg:px-24">
      <div className="max-w-4xl mx-auto prose prose-lg">
        <h1 className="text-4xl font-extrabold text-gray-900 mb-6">Terms of Service</h1>
        <p className="text-gray-600">Effective Date: August 19, 2025</p>

        <h2 className="text-2xl font-bold mt-8">1. Acceptance of Terms</h2>
        <p>
          By using Verve Tutor, operated as a sole proprietorship under Nathan
          Benayguev in Ontario, Canada, you agree to be bound by these Terms of
          Service and our Privacy Policy.
        </p>

        <h2 className="text-2xl font-bold mt-8">2. Eligibility</h2>
        <p>
          You must be at least 13 years old to use Verve Tutor. If you are under
          18, you may only use the Service with the involvement and consent of a
          parent or legal guardian. By using the Service, you represent and
          warrant that you meet these requirements.
        </p>

        <h2 className="text-2xl font-bold mt-8">3. User Responsibilities</h2>
        <p>
          You are responsible for any information you provide and for your
          interactions with other users. Verve Tutor does not oversee or verify
          the accuracy of information shared by tutors, students, or parents and
          disclaims all responsibility for user interactions.
        </p>

        <h2 className="text-2xl font-bold mt-8">4. Privacy</h2>
        <p>
          We only collect non-sensitive student information necessary for
          general educational purposes. Sensitive or personally identifiable
          information about students should not be entered into the Service.
          Please review our <a href="/privacy" className="text-blue-600 hover:underline">Privacy Policy</a>, which also governs your use of Verve Tutor.
        </p>

        <h2 className="text-2xl font-bold mt-8">5. Account Termination</h2>
        <p>
          To terminate an account, please contact us directly at
          <a href="mailto:vervetutor@gmail.com" className="text-blue-600 hover:underline"> vervetutor@gmail.com</a>.
        </p>

        <h2 className="text-2xl font-bold mt-8">6. Third-Party Services</h2>
        <p>
          Verve Tutor uses third-party services including Stripe (for payments),
          Google Cloud Platform, and Supabase. Your use of these services may be
          subject to their own terms and policies.
        </p>

        <h2 className="text-2xl font-bold mt-8">7. Disclaimer of Warranties</h2>
        <p>
          The Service is provided on an “as is” and “as available” basis without
          warranties of any kind, whether express or implied. We do not warrant
          that the Service will be uninterrupted, error-free, or secure.
        </p>

        <h2 className="text-2xl font-bold mt-8">8. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, Verve Tutor and Nathan
          Benayguev shall not be liable for any indirect, incidental,
          consequential, or punitive damages, including but not limited to loss
          of profits, data, goodwill, or business opportunities, arising from
          your use of the Service.
        </p>

        <h2 className="text-2xl font-bold mt-8">9. Changes to the Terms</h2>
        <p>
          We may update these Terms of Service from time to time. If we make
          significant changes, we will notify users through the Service or by
          email. Continued use of Verve Tutor after updates constitutes your
          acceptance of the revised Terms.
        </p>

        <h2 className="text-2xl font-bold mt-8">10. Governing Law</h2>
        <p>
          These Terms are governed by the laws of Ontario, Canada. Any disputes
          will be subject to the exclusive jurisdiction of the courts of
          Ontario.
        </p>

        <h2 className="text-2xl font-bold mt-8">11. Contact Information</h2>
        <p>
          If you have questions about these Terms, please contact us at
          <a href="mailto:vervetutor@gmail.com" className="text-blue-600 hover:underline"> vervetutor@gmail.com</a>.
        </p>
      </div>
    </div>
  );
}
